import { Component, OnInit } from '@angular/core';
import { LoginModel } from 'src/app/models/login';
import { EventService } from 'src/app/services/event-services/error-event.service';
import { AuthService } from 'src/app/services/http-services/authservice.service';
import { AuthLayoutRoutes } from 'src/app/services/navigation-services/auth-layout-routes.service';

@Component( {
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: [ './forgot-password.component.css' ]
} )
export class ForgotPasswordComponent implements OnInit {
  constructor ( private auth: AuthService, private errorEvent: EventService, private authroute: AuthLayoutRoutes ) { }

  Email: string;
  alert: string;
  isError: boolean;

  ngOnInit (): void {
    this.errorEvent.httpErrorMessageEvent.subscribe( message => {
      this.alert = message;
      this.isError = true;
    } );
  }

  async sendPasswordReset () {
    const data: LoginModel = {
      Username: this.Email,
      Password: ''
    };
    await this.auth.sendResetPasswordMail( data );
    this.authroute.navigateToPasswordResetsent();
  }
}
